import React from 'react';
import i18next from 'i18next';
import { Carousel, Container } from './styles';

export default () => {
  function renderText(lang) {
    return (
      <p
        dangerouslySetInnerHTML={{
          __html: i18next.t(lang, {interpolation: {escapeValue: false}})
        }}
      />
    );
  }

  return (
    <Carousel autoplay dots={false} effect="fade" easing="easeOutSine">
      <Container>
        {renderText('home.banner.carousel.first')}
      </Container>

      <Container>
        {renderText('home.banner.carousel.second')}
      </Container>

      <Container>
        {renderText('home.banner.carousel.third')}
      </Container>
    </Carousel>
  );
};
